import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  first3kg261hmihapu as first,
  last2n4gf5az1lkn4 as last,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  get_lastIndexld83bqhfgcdd as get_lastIndex_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Companion_instance2wec3srl1ini as Companion_instance } from './AsciiBitSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_HeaderFieldValueSeparators() {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  return HeaderFieldValueSeparators;
}
var HeaderFieldValueSeparators;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var HeaderValueWithParametersClass;
function HeaderValueWithParameters() {
  if (HeaderValueWithParametersClass === VOID) {
    class $ {
      static new_io_ktor_http_HeaderValueWithParameters_3vfckb_k$(content, parameters) {
        parameters = parameters === VOID ? emptyList() : parameters;
        var $this = createThis(this);
        $this.content_1 = content;
        $this.parameters_1 = parameters;
        return $this;
      }
      parameter_w3eqbz_k$(name) {
        var inductionVariable = 0;
        var last = get_lastIndex(this.parameters_1);
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var parameter = this.parameters_1.get_c1px32_k$(index);
            if (equals(parameter.name_1, name, true)) {
              return parameter.value_1;
            }
          }
           while (!(index === last));
        return null;
      }
      toString() {
        var tmp;
        if (this.parameters_1.isEmpty_y1axqb_k$()) {
          tmp = this.content_1;
        } else {
          var tmp_0 = this.content_1.length;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var _iterator__ex2g4s = this.parameters_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp_1 = sum;
            sum = tmp_1 + ((element.name_1.length + element.value_1.length | 0) + 3 | 0) | 0;
          }
          var size = tmp_0 + sum | 0;
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(size);
          this_0.append_22ad7x_k$(this.content_1);
          var inductionVariable = 0;
          var last = get_lastIndex(this.parameters_1);
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element_0 = this.parameters_1.get_c1px32_k$(index);
              this_0.append_22ad7x_k$('; ');
              this_0.append_22ad7x_k$(element_0.name_1);
              this_0.append_22ad7x_k$('=');
              // Inline function 'io.ktor.http.escapeIfNeededTo' call
              var this_1 = element_0.value_1;
              if (needQuotes(this_1))
                this_0.append_22ad7x_k$(quote(this_1));
              else
                this_0.append_22ad7x_k$(this_1);
            }
             while (!(index === last));
          tmp = this_0.toString();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HeaderValueWithParameters');
    HeaderValueWithParametersClass = $;
  }
  return HeaderValueWithParametersClass;
}
function needQuotes(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(_this__u8e3s4) === 0)
    return true;
  if (isQuoted(_this__u8e3s4))
    return false;
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var element = charCodeAt(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_HeaderFieldValueSeparators().contains_egozq6_k$(element))
      return true;
  }
  return false;
}
function quote(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  quoteTo(_this__u8e3s4, this_0);
  return this_0.toString();
}
function isQuoted(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  if (_this__u8e3s4.length < 2) {
    return false;
  }
  if (!(first(_this__u8e3s4) === _Char___init__impl__6a9atx(34)) || !(last(_this__u8e3s4) === _Char___init__impl__6a9atx(34))) {
    return false;
  }
  var startIndex = 1;
  $l$loop: do {
    var index = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(34), startIndex);
    if (index === get_lastIndex_0(_this__u8e3s4)) {
      break $l$loop;
    }
    var slashesCount = 0;
    var slashIndex = index - 1 | 0;
    while (charCodeAt(_this__u8e3s4, slashIndex) === _Char___init__impl__6a9atx(92)) {
      slashesCount = slashesCount + 1 | 0;
      slashIndex = slashIndex - 1 | 0;
    }
    if ((slashesCount % 2 | 0) === 0) {
      return false;
    }
    startIndex = index + 1 | 0;
  }
   while (startIndex < _this__u8e3s4.length);
  return true;
}
function quoteTo(_this__u8e3s4, out) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  out.append_22ad7x_k$('"');
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var element = charCodeAt(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var ch = element;
    if (ch === _Char___init__impl__6a9atx(92))
      out.append_22ad7x_k$('\\\\');
    else if (ch === _Char___init__impl__6a9atx(10))
      out.append_22ad7x_k$('\\n');
    else if (ch === _Char___init__impl__6a9atx(13))
      out.append_22ad7x_k$('\\r');
    else if (ch === _Char___init__impl__6a9atx(9))
      out.append_22ad7x_k$('\\t');
    else if (ch === _Char___init__impl__6a9atx(34))
      out.append_22ad7x_k$('\\"');
    else
      out.append_58al37_k$(ch);
  }
  out.append_22ad7x_k$('"');
}
var properties_initialized_HeaderValueWithParameters_kt_yu5xg;
function _init_properties_HeaderValueWithParameters_kt__z6luvy() {
  if (!properties_initialized_HeaderValueWithParameters_kt_yu5xg) {
    properties_initialized_HeaderValueWithParameters_kt_yu5xg = true;
    HeaderFieldValueSeparators = Companion_instance.of_5gnbr7_k$('()<>@,;:\\"/[]?={} \t\n\r');
  }
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance_0 as Companion_instance219cxyaprolfe,
  HeaderValueWithParameters as HeaderValueWithParameters2awuza444hhll,
};
//endregion

//# sourceMappingURL=HeaderValueWithParameters.mjs.map
